export const createGetUserCustomFontsRequest = () => {
  return {
    url: "/custom_fonts",
    method: "GET",
  };
};

export const createAddUserCustomFontRequest = (data) => {
  return {
    url: "/custom_fonts",
    method: "POST",
    data
  };
};
